// redux/reducers/oliCategoryReducer.js
import { ActionTypes } from "../constants/action-types";

const initialState = {
  oliCategory: null,
  isVisible: false,
  showFeedbackPopup: false,
};

const oliCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_OLI_CATEGORY:
      return {
        ...state,
        oliCategory: action.payload,
      };

    case ActionTypes.OPEN_OLI_POPUP:
      return {
        ...state,
        isVisible: true,
      };  
    
    case ActionTypes.CLOSE_OLI_POPUP:
      return {
        ...state,
        isVisible: false,
      };

    case ActionTypes.DISPLAY_FEEDBACK_POPUP:
      return {
        ...state,
        showFeedbackPopup: action.payload,
      };

    default:
      return state;
  }
};

export default oliCategoryReducer;